import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BeautybookService } from '@features/beautybook/services/beautybook.service';
import { faSpinner, faTimes } from '@fortawesome/free-solid-svg-icons';
import { DataListParameter } from '@shared/interfaces/data-list-parameter.interface';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'fc-selfie-select-dialog',
  templateUrl: './selfie-select-dialog.component.html',
  styleUrls: ['./selfie-select-dialog.component.css'],
})
export class SelfieSelectDialogComponent implements OnInit {
  faTimes = faTimes;

  selfies: any;
  @Input() selectedSelfie: any;
  @Output() changeSelfie: EventEmitter<any> = new EventEmitter();

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private beautybookService: BeautybookService
  ) {
    if (config.data) {
      this.selfies = config.data.selfies;
      this.selectedSelfie = config.data.selectedSelfie;
    }
  }
  ngOnInit(): void {}

  onSelectSelfie(selfie: any) {
    this.selectedSelfie = selfie;
    this.changeSelfie.emit(selfie);
    this.onCloseModal(selfie);
  }
  deleteSelfie(selfie: any) {
    this.beautybookService.deleteSelfie(selfie.id).subscribe((data) => {
      this.selfies = this.selfies.filter((s: any) => s.id !== selfie.id);
    });
  }
  onCloseModal(selfie: any = null) {
    if (selfie) {
      this.ref.close(selfie);
    } else {
      this.ref.close();
    }
  }
}
